import duaStore from './store'

export default class DuaModule {
  name = 'duaMessage'
  constructor({ store }) {
    store.registerModule(this.name, duaStore)
  }
}
